<template>
    <form v-on:submit.prevent class="SubForm">
        <h3>Contact Info</h3>
        <label>Name</label><input type="text" v-model="contact.name"/>
        <label>Lead Source</label><input type="text" v-model="contact.lead_source"/>
        <label>Organization Type</label>
        <select v-model="contact.type" default="0">
        <option v-for="opt in $store.organization_types" :key="opt.id" :value="opt.id">{{opt.name}}</option>
        </select>
        <label>Rating</label>
        <select v-model="contact.rating"><option>Cold</option><option>Warm</option><option>Hot</option></select>

        <h3>Primary Contact</h3>
        <label>Name</label><input type="text" v-model="contact.contact_name"/>
        <label>Email</label><input type="email" v-model="contact.contact_email"/>
        <label>Landline</label><input type="tel" v-model="contact.contact_landline"/>
        <label>Mobile</label><input type="tel" v-model="contact.contact_mobile"/>

        <h3>Business Details</h3>
        <label>Name</label><input type="text" v-model="contact.business_name"/>
        <label>Email</label><input type="email" v-model="contact.business_email"/>
        <label>Phone</label><input type="tel" v-model="contact.business_landline"/>

        <h3>Address</h3>
        <label>Street Address 1</label><input type="text" v-model="contact.address1"/>
        <label>Street Address 2</label><input type="text" v-model="contact.address2"/>
        <label>Suburb</label><input type="text" v-model="contact.locality"/>
        <label>State</label><input type="text" v-model="contact.province"/>
        <label>Postcode</label><input type="text" v-model="contact.postcode"/>
        <label>Country</label><input type="text" v-model="contact.country"/>

        <p><b>Notes</b></p>
        <textarea v-model="contact.notes"></textarea>
        <p><button @click="saveContact">Save</button></p>
    </form>
</template>

<script>
import {store} from '../store.js'
import {CallApi} from '../Utilities.js'
export default {
    name: 'OrganizationCreate',
    data: function() {
        return {
            contact : {
                name: '',
                rating: 'warm',
                salesperson: store.User.id,
                contact_name: '',
                contact_email: '',
                contact_landline: '',
                contact_mobile: '',
                business_name: '',
                business_email: '',
                business_landline: '',
                address1: '',
                address2: '',
                locality: '',
                province: '',
                postcode: '',
                country: '',
                notes: '',
                lead_source: '',
                type: 0,
            }
        }
    },
    methods: {
        saveContact: async function() {
            const apiResponse = await CallApi('POST', '/organizations', this.contact)
            if (apiResponse.contact) {
                this.$router.push(`/customers/${apiResponse.contact.id}`)
            }
        }
    }
}
</script>